/**
 * Dynamic price
 */

const productPageSections = document.querySelectorAll(".Product_Section");

productPageSections.forEach((section) => {
  registerProductPage(section);
});

function registerProductPage(section) {
  section.dataset.registered = true;
  const variantsJSON = JSON.parse(section.dataset.productInfo);
  const price = section.querySelector(".Product_Price");

  console.log(variantsJSON);

  const form = section.querySelector(".Product_Form");
  const id = form.querySelector("input[name*='id']");

  const options = form.querySelectorAll(".Product_Options.Options select");
  const properties = form.querySelectorAll(".Product_Options.Extras select");

  const quantitySelector = form.querySelector(
    ".Quantity_Selector input[name='quantity']"
  );
  let quantity = 1;

  quantitySelector.addEventListener("quantity:change", (e) => {
    quantity = quantitySelector.value;
    form.dispatchEvent(new Event("change"));
  });

  form.addEventListener("change", (e) => {
    let totalPrice = 0;
    let totalComparePrice = 0;
    let addedPrice = 0;
    /* update hidden variantID field */
    let selectedVariant = variantsJSON.find((v) => {
      let result = true;
      options.forEach((o, i) => {
        if (v[`option${i + 1}`] != o.value) {
          result = false;
        }
      });
      return result;
    });
    // Assign first available variant instead
    if (!selectedVariant) {
      selectedVariant = variantsJSON.find((v) => {
        let result = true;
        return v[`option1`] == options[0].value;
      });

      options.forEach((o, i) => {
        if (i > 0) {
          o.value = selectedVariant[`option${i + 1}`];
        }
      });
    }

    options.forEach((o, i) => {
      o.closest(".Select_Dropdown").dispatchEvent(new Event("change"));
    });

    calculatePossibleOptions();

    id.value = selectedVariant.id;

    properties.forEach((property) => {
      const value = property.value;

      // get dataset variant id from select option
      let options = property.querySelectorAll("option");
      options.forEach((option) => {
        if (option.value == value && option.dataset.priceAdd) {
          addedPrice += Number.parseFloat(option.dataset.priceAdd);
        }
      });
    });

    DisableImpossibleVariants(selectedVariant, options, properties);

    totalPrice = selectedVariant.price * quantity + addedPrice;
    totalComparePrice =
      selectedVariant.compare_at_price * quantity + addedPrice;

    let priceTag = price.querySelector(".price:not(.original)");
    let comparePriceTag = price.querySelector(".price.original");

    priceTag.textContent = `$${(totalPrice / 100).toFixed(2)}`;

    if (comparePriceTag) {
      comparePriceTag.textContent = `$${(totalComparePrice / 100).toFixed(2)}`;
    } else if (totalComparePrice > totalPrice) {
      comparePriceTag = document.createElement("span");
      comparePriceTag.classList.add("price", "original");
      comparePriceTag.textContent = `$${(totalComparePrice / 100).toFixed(2)}`;
      // append as first element
      price.insertBefore(comparePriceTag, price.firstChild);
    }

    if (comparePriceTag && totalComparePrice <= totalPrice) {
      comparePriceTag.remove();
    }
  });

  function DisableImpossibleVariants(selectedVariant, selects, id) {
    let availableVariants = [];

    // First get all variants that have the same first option from JSON
    selects.forEach((select, i) => {
      variantsJSON.forEach((variant) => {
        if (variant[`option${i + 1}`] == selectedVariant[`option${i + 1}`]) {
          // then add to available variants
          availableVariants.push(variant);
        }
      });
    });

    // Remove options that don't fit selected variant
    selects.forEach((select, i) => {
      if (i > 0) {
        let options = select.querySelectorAll("option");
        options.forEach((o, j) => {
          const exists = availableVariants.some((v) => {
            let result = false;
            if (v[`option${i + 1}`] == o.value) {
              result = true;
            }
            return result;
          });
          if (!exists) {
            o.disabled = true;
          } else {
            o.disabled = false;
          }
        });
      }
    });
  }

  const productMediaCarousels = document.querySelectorAll(
    ".Product_Media:not([data-registered])"
  );

  productMediaCarousels.forEach((carousel) => {
    carousel.dataset.registered = true;

    const mainMedia = Array.from(carousel.querySelectorAll(".Main_Image"));
    const toggles = Array.from(carousel.querySelectorAll(".Additional_Image"));

    let activeMedia = mainMedia.find((m) => m.classList.contains("Active"));

    const defaultId = mainMedia.indexOf(activeMedia);

    let activeToggle = toggles[defaultId];
    activeToggle.classList.add("Active");

    function setDefault() {
      prepareMedias();
      setActive(defaultId);
    }

    function setActive(id) {
      prepareMedias();
      activeMedia = mainMedia[id];
      activeMedia.classList.add("Active");
      activeToggle = toggles[id];
      activeToggle.classList.add("Active");
      // scroll parent to active element
      activeMedia.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest",
      });
    }

    function prepareMedias() {
      const lastMedia = activeMedia;
      const lastToggle = activeToggle;
      lastToggle.classList.remove("Active");
      lastMedia.classList.remove("Active");
    }

    toggles.forEach((t, i) => {
      t.addEventListener("click", () => {
        if (t.classList.contains("Active") && i != defaultId) {
          setDefault();
        } else if (!t.classList.contains("Active")) {
          setActive(i);
        }
      });
    });
  });

  const selects = form.querySelectorAll(".Select_Dropdown");
  const currentValues = {};

  selects.forEach((select, i) => {
    // get select elem
    const selectElem = select.querySelector("select");

    currentValues[i] = selectElem.value;

    select.addEventListener("click", (e) => {
      if(e.target == select) select.classList.toggle("Open");

      // close other selects
      selects.forEach((s) => {
        if (s != select) {
          s.classList.remove("Open");
        }
      });
    });

    // get all options (custom elements)
    const options = select.querySelectorAll(".Select_Dropdown_Option");
    const realOptions = selectElem.querySelectorAll("option");

    // change select value on custom option click
    options.forEach((option) => {
      option.addEventListener("click", () => {
        selectElem.value = option.dataset.value;
        form.dispatchEvent(new Event("change"));
      });
    });

    options[0].classList.add("Active");

    // add disabled class to options based on real options
    realOptions.forEach((option, i) => {
      if (option.disabled) {
        options[i].classList.add("Disabled");
      }
    });

    // listen to select changes
    select.addEventListener("change", () => {
      const value = selectElem.value;
      currentValues[i] = value;
      select.classList.remove("Open");

      // set active class to selected option
      options.forEach((option) => {
        if (option.dataset.value == value) {
          option.classList.add("Active");
        } else {
          option.classList.remove("Active");
        }
      });
    });
  });

  calculatePossibleOptions();

  function calculatePossibleOptions(){
    selects.forEach((select, i)=>{
      const selectElem = select.querySelector("select");
      const options = {};

      // iterate over object
      const keys = Object.keys(currentValues);

      keys.forEach((key)=>{
        if(key != i){
          const value = currentValues[key];
          options[`option${parseInt(key)+1}`] = value;
        }
      });

      // Check for current discount
      const currentVariant = variantsJSON.find((v)=>{
        let result = true;
        keys.forEach((key)=>{
          const query = `option${parseInt(key)+1}`;

          if(v[query] != currentValues[key]){
            result = false;
          }
        });
        return result;
      });

      // Percentage Discount
      //const currentDiscount = currentVariant && currentVariant['compare_at_price'] != currentVariant['price'] ? Math.max((currentVariant['compare_at_price'] - currentVariant['price']) / currentVariant['compare_at_price'] * 100, 0) : 0;

      // Amount Discount
      const currentDiscount = currentVariant && currentVariant['compare_at_price'] != currentVariant['price'] ? Math.max((currentVariant['compare_at_price'] - currentVariant['price']) / 100, 0) : 0;

      // check if variant exists for every options for this select
      const optionValues = select.querySelectorAll(".Select_Dropdown_Option");
      optionValues.forEach((option)=>{
        const value = option.dataset.value;
        options[`option${i+1}`] = value;

        const variant = variantsJSON.find((v)=>{
          let result = true;
          keys.forEach((key)=>{
            const query = `option${parseInt(key)+1}`;

            if(v[query] != options[query]){
              result = false;
            }
          });
          return result;
        });

        const available = variant ? variant['available'] : false;

        const discountTag = option.querySelector(".Discount");

        if(available){
          option.classList.remove("Disabled");
          if(discountTag) discountTag.classList.remove("Active");
        }else{
          option.classList.add("Disabled");
          if(discountTag) discountTag.classList.remove("Active");
        }

        // get discount on this variant
        const compare_at_price = variant ? variant['compare_at_price'] || variant['price'] : 0;
        const price = variant ? variant['price'] : 0;

        // Percentage Discount
        //const variantDiscount = compare_at_price == price ? 0 : (compare_at_price - price) / compare_at_price * 100;

        // Amount Discount
        const variantDiscount = compare_at_price == price ? 0 : (compare_at_price - price) / 100;
        
        const discount = variantDiscount != currentDiscount ? variantDiscount : 0;

        if(discountTag){
          if(discount > 0){
            discountTag.textContent = `Save $${Math.round(discount)}`;
            discountTag.classList.add("Active");
          }
          else{
            discountTag.classList.remove("Active");
          }
        }
      });

    });
  }
}

window.addEventListener("global:align", () => {
  const allProductPageSections = document.querySelectorAll(
    ".Product_Section:not([data-registered])"
  );
  allProductPageSections.forEach((section) => {
    registerProductPage(section);
  });
});
